module.exports = __webpack_public_path__ + "img/instructor2.d2fe06cd.png";